export default {
  discount: {
    id: 'funnel_payment_affirm_page_discount',
    defaultMessage: '⚡ You get a discount (yay) {amount}',
  },
}
